import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { Stack } from '@fiverr-private/layout_components';

export const LoadingState = () => (
  <Skeleton dataTestId="loading">
    <Stack gap="12" direction="column" padding="8">
      <SkeletonSquare height="32px" width="320px" />
      <Stack gap="4" direction="column">
        <SkeletonSquare height="24px" width="150px" />
        <SkeletonSquare height="16px" width="86px" />
      </Stack>
      <Stack gap="4" direction="column">
        <SkeletonSquare height="24px" width="150px" />
        <SkeletonSquare height="16px" width="86px" />
      </Stack>
    </Stack>
  </Skeleton>
);
